"use strict";
//
// Copyright © 2025 Hardcore Engineering Inc.
//
// Licensed under the Eclipse Public License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License. You may
// obtain a copy of the License at https://www.eclipse.org/legal/epl-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
//
// See the License for the specific language governing permissions and
// limitations under the License.
//
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmojiNode = void 0;
const core_1 = require("@tiptap/core");
exports.EmojiNode = core_1.Node.create({
    name: 'emoji',
    group: 'inline',
    inline: true,
    atom: true,
    selectable: false,
    addAttributes() {
        return {
            emoji: {
                default: ''
            },
            kind: {
                default: 'unicode'
            },
            image: {
                default: null
            }
        };
    },
    addCommands() {
        return {
            insertEmoji: (emoji, kind, image) => ({ commands }) => {
                if (kind === 'image')
                    emoji = `:${emoji}:`;
                return commands.insertContent({
                    type: this.name,
                    attrs: { emoji, kind, image }
                });
            }
        };
    },
    parseHTML() {
        return [
            {
                tag: `span[data-type="${this.name}"]`
            }
        ];
    },
    addNodeView() {
        return ({ node, HTMLAttributes }) => {
            const container = document.createElement('span');
            const containerAttributes = (0, core_1.mergeAttributes)({
                'data-type': this.name,
                class: 'emoji'
            }, HTMLAttributes);
            for (const [k, v] of Object.entries(containerAttributes)) {
                if (v !== null) {
                    container.setAttribute(k, v);
                }
            }
            if (node.attrs.kind === 'image') {
                const imgElement = document.createElement('img');
                imgElement.alt = node.attrs.emoji;
                imgElement.setAttribute('data-type', this.name);
                void this.options.getBlobRef(node.attrs.image).then((val) => {
                    imgElement.src = val.src;
                    imgElement.srcset = val.srcset;
                });
                container.append(imgElement);
            }
            else {
                container.append(node.attrs.emoji);
            }
            return {
                dom: container
            };
        };
    },
    renderHTML({ node, HTMLAttributes }) {
        if (node.attrs.kind === 'image') {
            return [
                'span',
                (0, core_1.mergeAttributes)({
                    'data-type': this.name,
                    class: 'emoji'
                }, HTMLAttributes),
                [
                    'img',
                    (0, core_1.mergeAttributes)({
                        'data-type': this.name,
                        src: node.attrs.image,
                        alt: node.attrs.emoji
                    })
                ]
            ];
        }
        return [
            'span',
            (0, core_1.mergeAttributes)({
                'data-type': this.name,
                class: 'emoji'
            }, HTMLAttributes),
            node.attrs.emoji
        ];
    }
});
//# sourceMappingURL=emoji.js.map